import axios from '@/util/request'
const baseURL = process.env.VUE_APP_API_URL

export default {
  getAlbumModuleTop: params => axios({ baseURL, url: '/api/product/open/module/list', method: 'get', params }), // 商城顶部固定专辑
  getAlbumModuleShow: params => axios({ baseURL, url: '/api/product/open/module/show', method: 'get', params }), // 获取首页专辑展示
  getAlbumModuleGroup: params => axios({ baseURL, url: '/api/product/open/module/group', method: 'get', params }), // 获取专辑分组
  getAlbumModuleList: data => axios({ baseURL, url: '/api/product/open/module/products', method: 'post', data }), // 获取专辑全部商品

  // 首页专辑
  getAlbumModuleIndexList: params => axios({ baseURL, url: '/api/product/open/module/main/list', method: 'get', params }) // 前台-首页专辑显示
}
